module.exports = __webpack_public_path__ + "img/service-icon-2.5c6c01c5.png";